import React from "react";
import PropTypes from "prop-types";

const CommentGlowIcon = ({ size = 20, className = "" }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        className={className}
    >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
);

CommentGlowIcon.propTypes = {
    size: PropTypes.number,
    className: PropTypes.string,
};

CommentGlowIcon.defaultProps = {
    size: 20,
    className: "",
};

export default CommentGlowIcon;
